import { render, staticRenderFns } from "./LoginAcesso.vue?vue&type=template&id=0f3ec620&scoped=true"
import script from "./LoginAcesso.vue?vue&type=script&lang=js"
export * from "./LoginAcesso.vue?vue&type=script&lang=js"
import style0 from "./LoginAcesso.vue?vue&type=style&index=0&id=0f3ec620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3ec620",
  null
  
)

export default component.exports